import Vue from 'vue'
import VueRouter from 'vue-router'
import all_app from 'components/all_app'
import add_app from 'components/add_app'
import app_index from 'components/app_index'
import message_list from 'components/message_list'
import read_message from 'components/read_message'
import change_password from 'components/change_password'
import app_detail from 'components/app_detail'
import head_portrait from 'components/head_portrait'
import main_page from '../main_page'
import developer_index from '../developer_index'
import review_app from 'components/review_app'
import developer_register from 'components/developer_register'
import agreement_register from 'components/agreement_register'
import developer_data from 'components/developer_data'
import manage_app from 'components/manage_app'
import edit_app from 'components/edit_app'
import store from 'vuex/store'
import publish_apply from 'components/publish_apply/index'

//订单
import order_list from 'components/order/list'
import manager_order_list from 'components/order/manager_order_list'
import confirm_cheque from 'components/order/confirm_cheque'
//登录注册
import login from 'components/loginGroup/login'
import login_index from 'components/loginGroup/login_index'
import register_yz from 'components/loginGroup/register_yz'
import register_index from 'components/loginGroup/register_index'
import register_success from 'components/loginGroup/register_success'
import forget_password from 'components/loginGroup/forget_password'
import company_register from 'components/company_register'
import company_data from 'components/company_data'
import agreement_company from 'components/agreement_company'

import login_page from 'components/loginGroup/login_page'
import forget_page from 'components/loginGroup/forget_page'
import register_page from 'components/loginGroup/register_page'
import register_lx from 'components/loginGroup/register_lx'

//用户反馈
import feedback_list from 'components/user_feedback/list'
import feedback_detail from 'components/user_feedback/detail'
import feedback_reply from 'components/user_feedback/reply'

//校园信息维护
import service_school from 'components/service_school'
import schoolinfo_edit from 'components/schoolinfo_edit'
import schoolinfo_add from 'components/schoolinfo_add'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		redirect: '/login',
		component: login,
	},
	{
		path: '/login',
		name: 'login',
		component: login,
		children: [
				{//默认登录页
					path: '/',
					name: 'login_page',
					component: login_page
				},
				{
					path: '/login_page',
					name: 'login_page',
					component: login_page
				},
//				{
//				path: '/login_index',
//				component: login_index,
//				children: [{
//						path: '/',
//						component: register_index
//					},
//					{
//						path: '/register_index',
//						name: 'register_index',
//						component: register_index
//					},
//					{
//						path: '/register_yz',
//						name: 'register_yz',
//						component: register_yz
//					},
//					{
//						path: '/register_success',
//						name: 'register_success',
//						component: register_success
//					}
//				]
//			},
			{//注册
				path: '/register_index',
				name: 'register_index',
				component: register_index,
				children:[
					{
						path: '/',
						name: 'register_page',
						component: register_page
					},
					{
						path: '/register_page',
						name: 'register_page',
						component: register_page
					},
					{
						path: '/register_yz',
						name: 'register_yz',
						component: register_yz
					},
					{
						path: '/register_success',
						name: 'register_success',
						component: register_success
					},
					{
						path: '/register_lx',
						name: 'register_lx',
						component: register_lx
					},

				]
			},
			{//忘记密码第二步
				path: '/forget_password',
				name: 'forget_password',
				component: forget_password
			},{//忘记密码第一步
				path: '/forget_page',
				name: 'forget_page',
				component: forget_page
			},
		]
	}, { //开发者注册页,暂放此处
		path: '/developer_register',
		name: 'developer_register',
		meta: {
			requireAuth: true,
		},
		component: developer_register,
		children: [{
			path: '/agreement_register',
			name: 'agreement_register',
			component: agreement_register
		},]
	},
	{ //企业开发者注册页
		path: '/company_register',
		name: 'company_register',
		meta: {
			requireAuth: true,
		},
		component: company_register,
		children: [{
			path: '/agreement_company',
			name: 'agreement_company',
			component: agreement_company
		},]
	},
	{
		path: '/developer_index',
		meta: {
			requireAuth: true,
		},
		component: developer_index,
		children: [{
				path: '/',
				component: app_index,
				meta: {
					requireAuth: true,
				},
			}, {
				path: '/app_index',
				name: 'app_index',
				meta: {
					requireAuth: true,
				},
				component: app_index
			},
			{
				path: '/all_app',
				name: 'all_app',
				meta: {
					requireAuth: true,
				},
				component: all_app
			}, {
				path: '/add_app',
				name: 'add_app',
				meta: {
					requireAuth: true,
				},
				component: add_app
			},{
				path: '/publish_apply',
				name: 'publish_apply',
				meta: {
					requireAuth: true,
				},
				component: publish_apply
			}, {
				path: '/message_list',
				name: 'message_list',
				meta: {
					requireAuth: true,
				},
				component: message_list
			}, {
				path: '/read_message',
				name: 'read_message',
				meta: {
					requireAuth: true,
				},
				component: read_message
			}, {
				path: '/app_detail',
				name: 'app_detail',
				meta: {
					requireAuth: true,
				},
				component: app_detail
			}, {
				path: '/change_password',
				name: 'change_password',
				meta: {
					requireAuth: true,
				},
				component: change_password
			}, {
				path: '/head_portrait',
				name: 'head_portrait',
				meta: {
					requireAuth: true,
				},
				component: head_portrait
			}, {
				path: '/review_app',
				name: 'review_app',
				meta: {
					requireAuth: true,
				},
				component: review_app
			}, {
				path: '/manage_app',
				name: 'manage_app',
				meta: {
					requireAuth: true,
				},
				component: manage_app
			},{
				path: '/service_school',
				name: 'service_school',
				meta: {
					requireAuth: true,
				},
				component: service_school
			},{
				path: '/schoolinfo_edit',
				name: 'schoolinfo_edit',
				meta: {
					requireAuth: true,
				},
				component: schoolinfo_edit
			},{
				path: '/schoolinfo_add',
				name: 'schoolinfo_add',
				meta: {
					requireAuth: true,
				},
				component: schoolinfo_add
			}, {
				path: '/developer_data',
				name: 'developer_data',
				meta: {
					requireAuth: true,
				},
				component: developer_data
			}, {
				path: '/company_data',
				name: 'company_data',
				meta: {
					requireAuth: true,
				},
				component: company_data
			}, {
				path: '/edit_app',
				name: 'edit_app',
				meta: {
					requireAuth: true,
				},
				component: edit_app
			},{
				path: '/order_list',
				name: 'order_list',
				meta: {
					requireAuth: true,
				},
				component: order_list
			},{
				path: '/manager_order_list',
				name: 'manager_order_list',
				meta: {
					requireAuth: true,
				},
				component: manager_order_list
			},{
				path: '/confirm_cheque',
				name: 'confirm_cheque',
				meta: {
					requireAuth: true,
				},
				component: confirm_cheque
			},{//用户反馈
				path: '/feedback_list',
				name: 'feedback_list',
				meta: {
					requireAuth: true,
				},
				component: feedback_list
			},{//用户反馈查看
				path: '/feedback_detail',
				name: 'feedback_detail',
				meta: {
					requireAuth: true,
				},
				component: feedback_detail
			},{//用户反馈回复
				path: '/feedback_reply',
				name: 'feedback_reply',
				meta: {
					requireAuth: true,
				},
				component: feedback_reply
			}
		]
	}
];

const router = new VueRouter({
	routes
});
router.beforeEach((to, from, next) => {
	if(to.matched.some(r => r.meta.requireAuth)) {
		if(localStorage.getItem("token")) {
			var loginUserType = localStorage.getItem("loginUserType");
			if(loginUserType == '101009') {
				if(to.fullPath.trim() == '/developer_index' || to.fullPath.trim() == '/manage_app' || to.fullPath.trim() == '/review_app' || to.fullPath.trim() == '/change_password' || to.fullPath.trim() == '/manager_order_list'
				|| to.fullPath.trim() == '/service_school' || to.fullPath.trim() == '/schoolinfo_edit' || to.fullPath.trim() == '/schoolinfo_add' || to.fullPath.trim() == '/confirm_cheque'
				|| to.fullPath.trim() == '/feedback_list' || to.fullPath.trim() == '/feedback_detail' || to.fullPath.trim() == '/feedback_reply' ){
					next();
				}else{
					alert('权限不足,无法访问该url');
				}
			} else if(loginUserType == '101005') {
				if(to.fullPath.trim() == '/developer_index' || to.fullPath.trim() == '/all_app' || to.fullPath.trim() == '/add_app' || to.fullPath.trim() == '/publish_apply'
				|| to.fullPath.trim() == '/app_index' || to.fullPath.trim() == '/change_password' || to.fullPath.trim() == '/message_list' || to.fullPath.trim() == '/read_message'
				|| to.fullPath.trim() == '/developer_data' || to.fullPath.trim() == '/app_detail' || to.fullPath == '/edit_app' || to.fullPath.trim() == '/order_list') {
					next();
				}else{
					alert('权限不足,无法访问该url');
				}
			} else if(loginUserType == '101006') {
				if(to.fullPath.trim() == '/developer_index' || to.fullPath.trim() == '/all_app' || to.fullPath.trim() == '/add_app'
				|| to.fullPath.trim() == '/app_index' || to.fullPath.trim() == '/change_password' || to.fullPath.trim() == '/message_list' || to.fullPath.trim() == '/read_message'
				|| to.fullPath.trim() == '/company_data' || to.fullPath.trim() == '/app_detail' || to.fullPath == '/edit_app' || to.fullPath.trim() == '/order_list') {
					next();
				}else{
					alert('权限不足,无法访问该url');
				}
			} else if(loginUserType == 'unrole') {
				if(to.fullPath.trim() == '/developer_register' || to.fullPath.trim() == '/company_register' || to.fullPath.trim() == '/agreement_register' || to.fullPath.trim() == '/agreement_company'){
					next();
				}else{
					alert('权限不足,无法访问该url');
				}
			} else {
				alert('权限不足,无法访问该url');
			}
		} else {
			next({ path: '/login' })
		}
	} else {
		next();
	}
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js